export const bmwTheme = {
  globals: {
    name: 'BMW',
    fontFamily: "'MINI Sans Serif', sans-serif;",
    fontFamilyHeadline: '"MINI Serif Headline"',
    fontFamilyBold: "'MINI Sans Serif', sans-serif;",
    bgColor: 'rgba(230, 230, 230, 1)',
    linkColor: 'rgba(28, 105, 212, 1)',
    linkColorHover: 'rgba(6, 83, 182, 1)',
    checkboxColor: 'rgba(0, 0, 0, 1)',
    checkboxColorActive: 'rgba(0, 0, 0, 1)',
    inputRequired: {
      asteriskColor: 'rgb(255, 68, 68)',
      textColor: 'rgb(255, 68, 68)',
      textFontSize: '14px',
    },
  },
  contentWrap: {},
  container: {
    bgColor: '#FFFFFF',
    width: '100%',
    padding: '40px 60px 60px',
    borderRadius: '0px',
    border: '1px solid rgba(230, 230, 230, 1)',
    boxShadow: '',
    margin: '0 auto',
    color: 'rgba(38, 38, 38, 1)',
  },
  documentCheckbox: {
    iconColor: 'rgba(28, 105, 212, 1)',
    iconHover: 'rgba(28, 105, 212, 0.6)',
    width: '100%',
    contentFontSize: '14px',
    margin: '20px',
  },
  icon: {
    docVerifyDotsColor: 'rgba(255, 255, 255, 1)',
    mainIconColor: 'rgba(28, 105, 212, 1)',
    colorHover: 'rgba(255, 255, 255, 1)',
    size: '32px',
    thickness: '0.2px',
  },
  otpInput: {
    width: '100%',
    columnGap: '10px',
    marginTop: '10px',
    marginBottom: '30px',
    inputHeight: '60px',
    inputBorder: '1px solid rgba(220, 220, 220, 1)',
    borderRadius: '0px',
    fontSize: '28px',
    focusColor: 'rgba(28, 105, 212, 1)',
    bgColor: 'rgba(250, 250, 250, 1)',
    focusBgColor: '#ffffff',
    fontColor: 'rgba(38, 38, 38, 1)',
    loadingColor: 'rgba(28, 105, 212, 1)',
  },
  pdfViewer: {
    pageBackground: '#FFFFFF',
    containerBorder: '1px solid rgba(235, 235, 235, 1)',
    scrollTrackColor: '#F1F3F7',
    scrollHandleColor: '#000000',
    scrollRadius: '0px',
    toolbox: {
      color: '#FFFFFF',
      bgColor: 'rgba(0, 0, 0, 0.70)',
      borderRadius: '4px',
      padding: '5px',
      boxShadow: '#none',
    },
    zoomButton: {
      bgColor: '#FFFFFF',
      color: '#000000',
      border: '1px solid #CECBD6',
      bgColorHover: '#F1F3F7',
      colorHover: '#000000',
      borderHover: '1px solid #CECBD6',
    },
    pageRangeInput: {
      trackColor: '#CECBD6',
      activeTrackColor: '#000000',
      thumbColor: '#000000',
      thumbHoverColor: '#000000CC',
      thumbFocusBorderColor: '',
    },
  },
  downloadDocumentButton: {
    bgColor: '#FFFFFF',
    color: '#000000',
    borderColor: '#CECBD6',
    bgColorHover: '#F1F3F7',
    colorHover: '#000000',
    borderColorHover: '#CECBD6',
    bgColorDisabled: '#F6F6F6',
    colorDisabled: '#91969B',
    borderColorDisabled: '#F6F6F6',
  },
  button: {
    bgColor: 'rgba(28, 105, 212, 1)',
    padding: '14px 40px',
    borderRadius: '0px',
    width: 'auto',
    border: '1px solid rgba(28, 105, 212, 1)',
    boxShadow: 'none',
    margin: '0',
    color: 'rgba(255, 255, 255, 1) !important',
    colorHover: 'rgba(255, 255, 255, 1) !important',
    bgColorHover: 'rgba(6, 83, 182, 1)',
    borderHover: '1px solid rgba(6, 83, 182, 1)',
    bgColorDisabled: 'rgba(28, 105, 212, 0.5)',
    borderDisabled: '1px solid rgba(28, 105, 212, 0.5)',
    colorDisabled: 'rgba(28, 105, 212, 1)',
    fontSize: '14px',
    fontWeight: '600',
  },
  buttonSecondary: {
    bgColor: 'transparent',
    padding: '14px 40px',
    borderRadius: '0px',
    width: 'auto',
    border: '1px solid #DCDBE2',
    boxShadow: 'none',
    margin: '0',
    color: '#34353A !important',
    colorHover: 'rgba(255, 255, 255, 1) !important',
    bgColorHover: 'rgba(6, 83, 182, 1)',
    borderHover: '1px solid rgba(6, 83, 182, 1)',
    bgColorDisabled: 'rgba(28, 105, 212, 0.5)',
    borderDisabled: '1px solid rgba(28, 105, 212, 0.5)',
    colorDisabled: 'rgba(28, 105, 212, 1)',
    fontSize: '14px',
    fontWeight: '600',
  },
  buttonDisabled: {
    bgColor: 'rgba(28, 105, 212, 0.5)',
    padding: '14px 40px',
    borderRadius: '0px',
    width: 'auto',
    border: '1px solid rgba(28, 105, 212, 0.5)',
    boxShadow: 'none',
    margin: '0',
    color: 'rgba(28, 105, 212, 1) !important',
    colorHover: 'rgba(28, 105, 212, 1) !important',
    bgColorHover: 'rgba(28, 105, 212, 0.5)',
    borderHover: '1px solid rgba(28, 105, 212, 0.5)',
    fontSize: '14px',
    fontWeight: '600',
  },
  header: {
    color: 'rgba(38, 38, 38, 1)',
    fontSize: '1.625rem',
    lineHeight: '2.25rem',
    fontSizeMobile: '1.25rem',
    lineHeightMobile: '1.9375rem',
    margin: '15px 0',
    textAlign: 'center',
    width: '100%',
  },
  selectInput: {
    borderRadius: '1',
    borderWidth: '1px',
    borderColorFocus: 'rgba(28, 105, 212, 1)',
    colorSelected: 'rgba(242, 248, 255, 1)',
    backgroundColorSelected: 'rgba(28, 105, 212, 1)',
    backgroundColorFocus: 'rgba(208, 227, 255, 1)',
    currentBg: 'rgba(242, 248, 255, 1)',
    indicatorColorFocus: 'rgb(102, 102, 102)',
    indicatorColorHover: 'rgb(153, 153, 153)',
    danger: 'rgba(226,64,40,1)',
    dangerLight: 'rgba(226,64,40,0.5)',
  },
  symbol: {
    primary: 'rgba(28, 105, 212, 1)',
    secondary: 'rgba(255, 255, 255, 1)',
    tenary: 'rgba(242, 242, 242, 1)',
  },
  textInput: {
    bgColor: 'white',
    padding: '14px',
    borderRadius: '0px',
    border: '1px solid rgba(220, 220, 220, 1)',
    boxShadow: 'none',
    margin: '0',
    color: 'gray',
    colorFocus: 'rgba(38, 38, 38, 1)',
    bgColorFocus: 'white',
    borderFocus: '1px solid rgba(220, 220, 220, 1)',
    bgColorDisabled: 'silver',
    borderDisabled: 'gray',
    colorDisabled: 'white',
    fontSize: '14px',
    fontWeight: '400',
    outline: '2px solid rgba(28, 105, 212, 1)',
    errorColor: '#d91111',
  },
  brandBar: {
    bgColor: 'white',
    padding: '30px',
    margin: '0 0 30px 0',
    border: 'none',
    boxShadow: 'none',
    justifyContent: 'normal',
  },
  wrapXs2a: {
    fontFamily: "'MINI Sans Serif', sans-serif;",
    fontFamilyHeadline: '"MINI Serif Headline"',
    bgColor: 'rgba(230, 230, 230, 1)',
    linkColor: 'rgba(28, 105, 212, 1)',
    linkColorHover: 'rgba(6, 83, 182, 1)',
    checkboxColor: 'rgba(0, 0, 0, 1)',
    checkboxColorActive: 'rgba(0, 0, 0, 1)',
    backButton: {
      borderColor: 'rgba(220, 220, 220, 1)',
      color: 'gray',
      colorHover: 'rgba(38, 38, 38, 1)',
      disabled: 'silver',
    },
    input: {
      bgColor: 'white',
      padding: '14px',
      borderRadius: '0px',
      border: '1px solid rgba(220, 220, 220, 1)',
      boxShadow: 'none',
      margin: '0',
      color: 'gray',
      colorFocus: 'rgba(38, 38, 38, 1)',
      bgColorFocus: 'white',
      borderFocus: '1px solid rgba(220, 220, 220, 1)',
      bgColorDisabled: 'silver',
      borderDisabled: 'gray',
      colorDisabled: 'white',
      fontSize: '14px',
      fontWeight: '400',
      outline: '2px solid rgba(28, 105, 212, 1)',
      errorColor: '#d91111',
    },
    button: {
      bgColor: 'rgba(28, 105, 212, 1)',
      padding: '14px 40px',
      borderRadius: '0px',
      width: 'auto',
      border: '1px solid rgba(28, 105, 212, 1)',
      boxShadow: 'none',
      margin: '0',
      color: 'rgba(255, 255, 255, 1) !important',
      colorHover: 'rgba(255, 255, 255, 1) !important',
      bgColorHover: 'rgba(6, 83, 182, 1)',
      borderHover: '1px solid rgba(6, 83, 182, 1)',
      bgColorDisabled: 'rgba(28, 105, 212, 0.5)',
      borderDisabled: '1px solid rgba(28, 105, 212, 0.5)',
      colorDisabled: 'rgba(28, 105, 212, 1)',
      fontSize: '14px',
      fontWeight: '600',
    },
  },
  wrapKlarna: {
    bgColor: 'rgba(230, 230, 230, 1)',
  },
  wrapKontomatik: {
    bgColor: '#FFF',
    textColor: '#000',
    borderColor: 'rgba(230, 230, 230, 1)',
    headerColor: 'rgba(38, 38, 38, 1)',
    primaryColor: 'rgba(28, 105, 212, 1)',
    primaryReverseColor: '#FFF',
    secondaryColor: '586374',
    mainHoverColor: 'rgba(6, 83, 182, 1)',
    mainHoverReverseColor: '#FFF',
    listHoverColor: '#F5F5F5',
    disabledColor: '#CED4DA',
    errorColor: '#BB0000',
    borderRadius: '0px',
    width: '100%',
    padding: '40px 60px 60px',
    boxShadow: '',
    margin: '0 auto',
  },
  progressBar: {
    time: 180,
    secondChance: true,
    showCounter: true,
    height: '24px',
    margin: '40px 0 10px 0',
    padding: '0 20px',
    border: '1px solid rgba(220, 220, 220, 1)',
    borderRadius: '4px',
    background: 'white',
    barFill: 'rgba(28, 105, 212, 1)',
    counterMargin: '20px 0',
    counterPadding: '0',
    counterFontSize: '24px',
    counterColor: 'rgba(38, 38, 38, 1)',
    infoMessageTextAlign: 'center',
    infoMessageFontSize: '12px',
    infoMessageMargin: '6px 0 0 0',
  },
  stepper: {
    borderColor: 'rgba(67, 21, 128, 1)',
    fontSizeTitle: '12px',
    fontSizeDesc: '10px',
  },
  loadingSpinner: {
    primary: 'rgba(28, 105, 212, 1)',
    bgColor: '#FBFBFB',
  },
  tabSwitcher: {
    borderBottom: '2px solid #dbdbdb',
    buttonColor: '#9b9b9b',
    buttonBorderBottom: '4px solid rgba(28, 105, 212, 1)',
    buttonColorActive: '#000',
  },
  errorPage: {
    title: {
      color: 'rgba(6, 83, 182, 1)',
    },
    subtitle: {
      color: '#98959f',
    },
    svg: {
      fill1: 'none',
      fill2: '#ffffff',
      fill3: '#000',
      fill4: 'rgba(6, 83, 182, 1)',
    },
  },
  popup: {
    clickOutsideEnabled: true,
  },
  videoIdCallToActionButton: {
    bgColor: 'transparent',
    padding: '14px 40px',
    borderRadius: '0px',
    width: '150px',
    border: 'none',
    boxShadow: 'none',
    margin: '32px 0 0 0',
    color: '#2a6380',
    colorHover: '#2a6380',
    bgColorHover: 'transparent',
    borderHover: 'transparent',
    bgColorDisabled: 'transparent',
    borderDisabled: 'transparent',
    colorDisabled: '#000',
    fontSize: '18px',
    fontWeight: '700',
    textDecoration: 'underline',
  },
  videoIdPhoneChangeButton: {
    color: '#1C69D4',
  },
}
